export default __webpack_public_path__ + "static/media/download-button.9b23c15e.svg";